// import external dependencies
import "jquery";
import "magnific-popup/dist/jquery.magnific-popup.min";
import "./scripts.js";



// WEBPACK FOOTER //
// ./scripts/main.js